export const i18nPath = 'transmissionCircuit.barePropertyDonations.ownershipList.'

export default {
  title: 'Détail de la détention du bien',
  subtitle: 'Sur la base des éléments renseignés',
  item: {
    title: 'Détenteur',
    label: {
      type: 'Détention',
      share: 'Quote-part'
    },
    type: {
      owner: 'Propre',
      community: 'Commune',
      acquests_society: 'Société d\'acquêts',
      indivision: 'Indivis'
    }
  }
}
